import { BackOfficeDtoConverter } from 'shared/services/backoffice-data-provider';

import { Segment } from './models/segment.model';

export class SegmentDtoConverter extends BackOfficeDtoConverter {
  convert(dto: any) {
    return Segment.fromDto(dto) as any;
  }
}
